var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var SFX_VOLUME = 0.35;
// Fade durations in second
var FADE_IN_TIME = 1.0;
var FADE_OUT_TIME = 1.0;
var SingleSFXPlayer = /** @class */ (function () {
    function SingleSFXPlayer(source, context, destination) {
        var _this = this;
        this.context = context;
        this.fadeOutDelay = null;
        this.track = document.createElement("audio");
        this.track.crossOrigin = "use-credentials";
        this.track.loop = false;
        this.track.src = source;
        this.track.onloadedmetadata = function () {
            _this.track.loop = _this.track.duration > 5;
        };
        var media = context.createMediaElementSource(this.track);
        this.volume = context.createGain();
        this.volume.gain.setValueAtTime(0, this.context.currentTime);
        media.connect(this.volume);
        this.volume.connect(destination);
    }
    SingleSFXPlayer.prototype.play = function () {
        if (this.fadeOutDelay != null) {
            clearTimeout(this.fadeOutDelay);
            this.fadeOutDelay = null;
        }
        else {
            this.track.currentTime = 0;
        }
        this.track.play();
        this.volume.gain.setTargetAtTime(1, this.context.currentTime, 
        // The "time constant" of setTargetAtTime creates an exponential change (1 - e^(-n)). Its is approximately equal to one third of the desired duration.
        FADE_IN_TIME / 3);
    };
    SingleSFXPlayer.prototype.stop = function () {
        var _this = this;
        if (this.fadeOutDelay != null || this.track.paused)
            return;
        this.volume.gain.setTargetAtTime(0, this.context.currentTime, FADE_OUT_TIME / 3);
        this.fadeOutDelay = setTimeout(function () {
            _this.track.pause();
            _this.fadeOutDelay = null;
        }, 1200);
    };
    return SingleSFXPlayer;
}());
var BackgroundFXPlayer = /** @class */ (function () {
    function BackgroundFXPlayer() {
        var _this = this;
        this.channels = {};
        this.targetTrack = null;
        this.enabled = true;
        this.refreshTimeout = null;
        this.clickListener = function () {
            if (_this.context.state === "suspended") {
                _this.context.resume();
            }
        };
        this.context = new (window.AudioContext ||
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any -- Older browsers */
            window.webkitAudioContext)();
        window.addEventListener("click", this.clickListener);
        this.masterVolume = this.context.createGain();
        this.masterVolume.connect(this.context.destination);
    }
    BackgroundFXPlayer.prototype.setTrack = function (track) {
        this.targetTrack = track;
        this.requestRefresh();
    };
    BackgroundFXPlayer.prototype.setEnabled = function (enabled) {
        this.enabled = enabled;
        this.requestRefresh();
    };
    BackgroundFXPlayer.prototype.requestRefresh = function () {
        var _this = this;
        if (this.refreshTimeout == null) {
            this.refreshTimeout = setTimeout(function () {
                _this.refreshTimeout = null;
                _this.refresh();
            }, 1);
        }
    };
    BackgroundFXPlayer.prototype.refresh = function () {
        var e_1, _a;
        var _this = this;
        if (this.enabled) {
            // Activate target track
            if (this.targetTrack) {
                if (!(this.targetTrack in this.channels)) {
                    var track_1 = new SingleSFXPlayer(this.targetTrack, this.context, this.masterVolume);
                    this.channels[this.targetTrack] = track_1;
                }
                var track = this.channels[this.targetTrack];
                track.play();
            }
            // Stop other tracks
            Object.entries(this.channels).forEach(function (_a) {
                var _b = __read(_a, 2), track = _b[0], audio = _b[1];
                if (track !== _this.targetTrack) {
                    audio.stop();
                }
            });
        }
        else {
            try {
                for (var _b = __values(Object.entries(this.channels)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), audio = _d[1];
                    audio.stop();
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    BackgroundFXPlayer.prototype.dispose = function () {
        this.setEnabled(false);
        window.removeEventListener("click", this.clickListener);
        this.context.close();
    };
    BackgroundFXPlayer.prototype.setVolume = function (volume) {
        this.masterVolume.gain.setTargetAtTime(volume * SFX_VOLUME, this.context.currentTime, 0.06);
    };
    return BackgroundFXPlayer;
}());
export { BackgroundFXPlayer };
